import { Box, SimpleGrid, VStack } from '@chakra-ui/react';
import { usePropertiesModel } from '@common/models/PropertiesModel';
import React from 'react';

import { SectionHeader } from '../common/SectionHeader';

type TopEmployersProps = {
  children?: React.ReactNode;
};

type ColumnsMode = 'single' | 'multiple';

export const TopEmployers: React.FC<TopEmployersProps> = () => {
  const { property } = usePropertiesModel();
  const employersCount = property?.sfr?.info.nearby_employers?.length ?? 0;
  const displayMode: ColumnsMode = employersCount > 1 ? 'multiple' : 'single';
  const columns: Record<ColumnsMode, number[]> = {
    multiple: [1, 2, 3, 4],
    single: [1],
  };
  const dim: Record<ColumnsMode, [width: string, height: string]> = {
    multiple: ['150px', '65px'],
    single: ['100%', '130px'],
  };
  return (
    <VStack alignItems={['center', 'flex-start']}>
      <Box alignSelf={['center', 'flex-start']} mb={['20px', '40px']}>
        <SectionHeader text={'Top Employers in the Area'} />
      </Box>
      <SimpleGrid
        w={['150px', 'full']}
        columns={columns[displayMode]}
        gap={['20px', '30px']}
        alignItems={['center', 'flex-start']}>
        {property?.sfr?.info.nearby_employers?.map((employer, i) => (
          <Box
            key={`employer-${i}`}
            maxW="150px"
            h={dim[displayMode][1]}
            backgroundImage={employer.url}
            backgroundSize="contain"
            backgroundRepeat={'no-repeat'}
            backgroundPosition="center center"></Box>
        ))}
      </SimpleGrid>
    </VStack>
  );
};
